import React from 'react';

import { Field } from 'formik';

import { FormikFieldProps } from '@common/react/components/Forms/FormikField/FormikField';
import FormikFieldBase, {
	FormikFieldExtensions as FormikFieldExtensionsBase,
} from '@common/react/components/Formik/base/FormikField';
import { FormikList } from '@common/react/components/Forms/FormikList/FormikList';
import PathInput from '@common/react/components/Forms/PathInput/PathInput';
import ColorPicker, { ColorPickerProps, ColorPickerMode } from '@common/react/components/UI/ColorPicker/ColorPicker';
import { SelectForEnum } from '@common/react/components/Formik/advanced/SelectForEnum';
import FormikFieldTimeZoneSelect from '@common/react/components/Formik/advanced/TimeZoneSelect';
import FormFieldZipAutocomplete from '@common/react/components/Formik/advanced/ZipAutocomplete';
import FormAvatar from '@common/react/components/Formik/advanced/FormAvatar';
import { FormikFieldSwitch } from '@common/react/components/Formik/advanced/FormikFieldSwitch';

const FormikField: typeof FormikFieldBase & FormikFieldExtensions = (props: FormikFieldProps) => <FormikFieldBase {...props} />;

interface FormikFieldColorPickerProps {
	fieldName?: string;
	colorPickerProps?: Omit<ColorPickerProps, 'mode' | 'onChange' | 'color'>;
	containerClassName?: string;
	labelClassName?: string;
	label?: string;
}

const FormikFieldColorPicker = (props: FormikFieldColorPickerProps) => {
	const {
		fieldName = 'color',
		colorPickerProps,
		containerClassName,
		label,
	} = props;
	return <Field name={fieldName}>
		{({ field, form }) => {
			const colorPicker = (<div className="is-relative color-picker">
				<ColorPicker
					{...colorPickerProps}
					mode={ColorPickerMode.EDIT}
					color={field.value}
					onChange={(color) => form.setFieldValue(field.name, color.hex)}
				/>
			</div>);
			return containerClassName || label ? <div className={containerClassName}>
				{label && <label>{label}</label>}
				{colorPicker}
			</div> : colorPicker;
		}}
	</Field>;
};

FormikField.Input = FormikFieldBase.Input;
FormikField.TextArea = FormikFieldBase.TextArea;
FormikField.Email = FormikFieldBase.Email;
FormikField.Phone = FormikFieldBase.Phone;
FormikField.List = FormikList;
FormikField.PathInput = PathInput;
FormikField.PhoneOrEmail = FormikFieldBase.PhoneOrEmail;
FormikField.ColorPicker = FormikFieldColorPicker;
FormikField.SelectForEnum = SelectForEnum;
FormikField.TimeZoneSelect = FormikFieldTimeZoneSelect;
FormikField.ZipAutocomplete = FormFieldZipAutocomplete;
FormikField.Avatar = FormAvatar;
FormikField.Switch = FormikFieldSwitch;

interface FormikFieldExtensions extends FormikFieldExtensionsBase {
	List: typeof FormikList;
	PathInput: typeof PathInput;
	ColorPicker: typeof FormikFieldColorPicker;
	SelectForEnum: typeof SelectForEnum;
	TimeZoneSelect: typeof FormikFieldTimeZoneSelect;
	ZipAutocomplete: typeof FormFieldZipAutocomplete;
	Avatar: typeof FormAvatar;
	Switch: typeof FormikFieldSwitch;
}

export default FormikField;
